import React from "react";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent, { DialogContentProps as MuiDialogContentProps } from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import { Close } from "@mui/icons-material";

type DialogTitleProps = {
  id?: string;
  children: React.ReactNode;
  onClose: ((event: React.MouseEvent | React.KeyboardEvent) => void) | false;
}

export const DialogTitle: React.FC<DialogTitleProps> = (props) => {
  const { children, onClose, ...other } = props;

  let title: React.ReactNode = children;
  if (typeof children === "string") {
    title = (
      <Typography component="span" variant="h6" style={onClose ? { paddingRight: "2em" } : {}}>
        {children}
      </Typography>
    );
  }
  return (
    <MuiDialogTitle {...other}>
      {title}
      {onClose && (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: theme => theme.spacing(1),
            top: theme => theme.spacing(1),
            color: theme => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      )}
    </MuiDialogTitle>
  );
};

export const DialogContent = React.forwardRef<HTMLDivElement, MuiDialogContentProps>(
  (props, ref) => {
    const { sx, ...rest } = props;
    return (
      <MuiDialogContent
        ref={ref}
        sx={{
          // Increase specificity to override MUI's default adjacent-sibling rule
          "&&": { paddingTop: 2 },
          ...sx,
        }}
        {...rest}
      />
    );
  },
);

DialogContent.displayName = "DialogContent";

export const DialogActions = MuiDialogActions;
